import { ColumnState, FilterModel } from 'ag-grid-community';

import { ESessionStorage } from '@/types/storage';

export interface IDashboardTableSetup {
  filterModel?: FilterModel;
  columnState?: ColumnState[];
  page?: number;
  size?: number;
  scrollTop?: number;
  scrollLeft?: number;
}

export const readDashboardTableSetup = (): IDashboardTableSetup => {
  try {
    const raw = sessionStorage.getItem(ESessionStorage.DASHBOARD_TABLE_SETUP);

    return raw ? (JSON.parse(raw) as IDashboardTableSetup) : {};
  } catch (error) {
    console.error('Failed to read the dashboard table setup: ', error);

    return {};
  }
};

export const writeDashboardTableSetup = (setup: IDashboardTableSetup) => {
  sessionStorage.setItem(
    ESessionStorage.DASHBOARD_TABLE_SETUP,
    JSON.stringify({ ...readDashboardTableSetup(), ...setup }),
  );
};
